"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_client_1 = require("./base_client");
var template = require("@reverbdotcom/url-template");
var user_store_1 = require("../reverb-js-common/user_store");
var I18n = require("i18n-js");
var albumList = template.parse(LP_API_HOST + "/albums/{?albums,per_page}");
exports.albumShow = template.parse(LP_HOST + "/albums/{slug}");
var LPAPIClient = /** @class */ (function (_super) {
    tslib_1.__extends(LPAPIClient, _super);
    function LPAPIClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LPAPIClient.prototype.beforeRequest = function () {
        Object.assign(this.defaultHeaders, {
            'X-Display-Currency': user_store_1.default.getState().currency,
            'X-Shipping-Region': user_store_1.default.getState().shippingRegionCode,
            'Accept-Language': I18n.locale,
        });
    };
    LPAPIClient.prototype.albums = function (albums) {
        var url = albumList.expand({ albums: albums });
        return this.get(url);
    };
    return LPAPIClient;
}(base_client_1.default));
var client = new LPAPIClient();
client.setDefaultHeaders({
    'Content-Type': 'application/json',
});
exports.default = client;
//# sourceMappingURL=lp_api_client.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/lib/lp_api_client.js
// module id = MVlx
// module chunks = 20 21